<template>
  <div id="simulation-time-chart"></div>
</template>

<script>
  import d3 from 'd3'
  import c3 from 'c3'

  export default {
    name: 'simulation-time-chart',
    props: {
      value: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    data: function () {
      return {
      }
    },
    computed: {
      regions () {
        // const data = this.value.simulate
        // const simulValue = data.simul_value
        // const minValue = data.lower_bdd
        // const maxValue = data.maxSimulvalue
        // const minIdx = axis.indexOf(minValue)
        // const maxIdx = axis.indexOf(maxValue)
        //
        // const regions = [
        //   {axis: 'x', start: minIdx, end: maxIdx, class: 'regionX'}
        // ]

        return []
      }
    },
    methods: {
      init: function () {
        const data = this.value.simulate
        const regions = [
          {axis: 'x', start: data.lower_bdd_idx, end: data.upper_bdd_idx, class: 'regionX'}
        ]

        // 발전시간 시뮬레이션 그래프
        let chart = {
          bindto: '#simulation-time-chart',
          data: {
            x: 'x',
            columns: [
              ['x'].concat(data.simul_axis),
              ['빈도수'].concat(data.simul_value)
            ],
            type: 'bar'
          },
          axis: {
            x: {
              type: 'category',
              tick: {
                culling: {
                  max: 8
                },
                fit: true,
                centered: true,
                multiline: false
              },
              label: {
                text: '(발전시간)'
              }
            },
            y: {
              label: {
                text: '(빈도수)'
              }
            }
          },
          bar: {
            // width: 10
          },
          grid: {
            y: {
              show: true
            }
          },
          regions: regions,
          color: {
            pattern: ['#adb5bd']
          },
          tooltip: {
            format: {
              value: function (value) {
                return value + '회'
              }
            }
          }
        }

        // 차트 초기화
        c3.generate(chart)

        this.$nextTick(() => {
          this.drawAreaSpline()
        })
      },
      drawAreaSpline: function () {
        /**
         * 차트내 지정된 영역을 표시하는 함수입니다. (신뢰구간)
         */

        const dx = d3.selectAll('#simulation-time-chart .regionX rect')[0][0].width.animVal['value'] / 2
        const tmp = parseInt(d3.selectAll('#simulation-time-chart .regionX rect')[0][0].x.animVal['value']) + dx

        d3.selectAll('#simulation-time-chart .regionX')
          .append('text')
          .text('95% 신뢰구간')
          .attr('transform', `translate(${tmp}, 25)`)
          .style('text-anchor', 'middle')
          .style('font-size', '15')
          .style('font-weight', 'bold')
          .style('color', 'black')
          .style('fill-opacity', '1')

        d3.selectAll('#simulation-time-chart .c3-axis-y').attr('transform', 'translate(-10, 0)')
        d3.selectAll('#simulation-time-chart .c3-axis-x-label').attr('dx', '0')
        d3.selectAll('#simulation-time-chart .c3-axis-x-label').attr('dy', '3.5em')
      }
    },
    created: function () {
    },
    mounted: function () {
      this.init()
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/chart/SimulationTimeChart.vue